import React from "react";
import TransferCreateContainer from "containers/panel/reseller/transfer-create-container";
import { Helmet } from "react-helmet";

const ResellerTransferCreatePage = () => {
  return (
    <>
      <Helmet>
        <title>Bayiye Transfer | Skypay</title>
      </Helmet>
      <TransferCreateContainer />
    </>
  );
};

export default ResellerTransferCreatePage; 